import React from 'react';
import './components.css';
import dogsPreview from '../data/nycdogs.jpg';
import cafePreview from '../data/sundaycounter.jpg';
import rewindPreview from '../data/rewind.svg';

const projects = [
    {
        href: 'https://sunwooha.github.io/nycdogs/',
        label: 'Projects 🐶',
        title: 'NYC Dogs',
        desc: 'A visual tour of breeds, ages, and names across the five boroughs — built with D3.',
        image: dogsPreview,
        alt: 'Preview of the NYC Dogs visualization',
    },
    {
        href: '/sunday-counter/',
        label: 'Projects ☕',
        title: 'Sunday Counter',
        desc: 'Cafe analytics for what people order, which drinks and pastries carry the week, and who shows up for them — built with D3.',
        image: cafePreview,
        alt: 'Preview of the Sunday Counter cafe dashboard',
    },
    {
        href: '/rewind/',
        label: 'Projects 🎬',
        title: 'Rewind',
        desc: 'A visual essay of my Netflix nights — when I watched, what filled the hours, and which shows I came back to — built with D3.',
        image: rewindPreview,
        alt: 'Preview of Rewind, a heatmap of viewing days',
    },
];

function Project() {
    return (
        <section className='projects' id='projects'>
            {projects.map((project) => (
                <a
                    key={project.title}
                    className='tile project-tile'
                    href={project.href}
                    target='_blank'
                    rel='noopener noreferrer'
                >
                    <div className='project-top'>
                        <div className='tile-label'>{project.label}</div>
                        <span className='project-arrow' aria-hidden='true'>↗</span>
                    </div>
                    <img className='project-image' src={project.image} alt={project.alt} />
                    <div className='project-body'>
                        <h2 className='project-title'>{project.title}</h2>
                        <p className='project-desc'>{project.desc}</p>
                    </div>
                </a>
            ))}
        </section>
    );
}

export default Project;
